import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CancelPlanFeedBack from "./component";
import { submitCancellationFeedback } from "../confirmation/actions";
import {
  accountReActivate,
  getOrderDataByUserId,
} from "../settings/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      submitCancellationFeedbackConnect: submitCancellationFeedback,
      AccountReActivateConnect: accountReActivate,
      getOrderDataByUserIdConnect: getOrderDataByUserId,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(CancelPlanFeedBack);
